export const translations = {
  de: {
    nav: {
      home: "Start",
      services: "Leistungen",
      gallery: "Galerie",
      whyUs: "Warum wir",
      reviews: "Bewertungen",
      contact: "Kontakt",
      cta: "Anfrage",
    },
    hero: {
      tagline: "Premium Mobiler Service • Wien",
      title1: "Professionelle",
      title2: "Tiefenreinigung",
      title3: "mit Anspruch.",
      subtitle:
        "Mobile Polster- und Autoinnenreinigung in Wien. Wir kommen zu Ihnen — schnell, sicher, mit Resultaten, die man sofort sieht.",
      ctaPrimary: "Anfrage senden",
      ctaSecondary: "Leistungen ansehen",
      stats: [
        { value: "30+", label: "Aufträge erledigt" },
        { value: "4.9", label: "Kundenbewertung" },
        { value: "100%", label: "Sicher für Kinder & Tiere" },
      ],
    },
    mobile: {
      badge: "Mobiler Service",
      title: "Wir kommen zu Ihnen nach Hause oder ins Büro",
      desc: "Hetlav Detailing ist ein vollständig mobiler Service in Wien und Umgebung. Kein Hin- und Herfahren — wir bringen unser professionelles Equipment direkt zu Ihnen.",
    },
    services: {
      overline: "Leistungen & Preise",
      title: "Was wir für Sie reinigen",
      subtitle:
        "Transparente Preise ohne versteckte Kosten. Der finale Preis wird immer vor Arbeitsbeginn bestätigt.",
      auto: {
        title: "Auto Innenreinigung",
        subtitle: "Tiefenreinigung Ihres Fahrzeuginnenraums",
        suv: "SUV / VAN +20 €",
        packages: [
          {
            name: "Basic",
            price: "100",
            features: [
              "Staubsaugen des gesamten Innenraums",
              "Armaturenbrett, Konsole, Türverkleidungen",
              "Reinigung der Schweller",
              "Glasreinigung",
              "Reinigung der Fußmatten",
              "Leichter Duft",
            ],
          },
          {
            name: "Standard",
            price: "160",
            badge: "Beliebt",
            features: [
              "Vollständiges Staubsaugen + Kofferraum",
              "Sitz-Extraktion",
              "Teppich-Extraktion",
              "Matten und Schweller",
              "Türverkleidungen",
              "Kunststoffpflege mit Schutz",
              "Glasreinigung",
              "Abschlussduft",
            ],
            excludes: ["Dachhimmel nicht enthalten", "Tiefe Fleckenentfernung nicht enthalten"],
          },
          {
            name: "Premium",
            price: "190",
            features: [
              "Tiefenreinigung komplett",
              "Extraktion: Sitze, Teppich, Kofferraum",
              "Reinigung des Dachhimmels",
              "Entfernung hartnäckiger Flecken",
              "Kunststoffpflege mit Schutz",
              "Lederpflege",
              "Glasreinigung",
              "Schwellerreinigung",
              "Abschlussduft",
            ],
          },
        ],
      },
      addons: {
        title: "Zusatzleistungen",
        items: [
          { name: "Sitz-Extraktion (5 Plätze)", price: "80 €" },
          { name: "Kofferraum", price: "20 €" },
          { name: "Dachhimmel", price: "30 €" },
          { name: "Tierhaare entfernen", price: "30–50 €" },
          { name: "Starke Verschmutzung", price: "30 €" },
          { name: "Ozonbehandlung", price: "50 €" },
          { name: "LKW", price: "ab 180 €" },
        ],
      },
      furniture: {
        title: "Polster- & Möbelreinigung",
        subtitle: "Sofas, Matratzen, Stühle — sauber bis in die Tiefe",
        groups: [
          {
            label: "Stühle",
            note: "Preis abhängig von Größe und Verschmutzung",
            items: [
              { name: "Stoffstuhl", price: "25–35 €" },
              { name: "Großer Sessel", price: "50–60 €" },
            ],
          },
          {
            label: "Matratzen (pro Seite)",
            items: [
              { name: "Einzelbett", price: "70 €" },
              { name: "Doppelbett", price: "100 €" },
              { name: "Zweite Seite", price: "+70 € / +100 €" },
              { name: "Starke Flecken", price: "+30 €" },
            ],
          },
          {
            label: "Sofas",
            items: [
              { name: "2-Sitzer", price: "120 €" },
              { name: "3-Sitzer", price: "150 €" },
              { name: "Ecksofa (L)", price: "180 €" },
              { name: "Großes Ecksofa (U)", price: "220 €" },
            ],
          },
          {
            label: "Zusätzlich",
            items: [
              { name: "Dekokissen", price: "5–10 €" },
              { name: "Starke Flecken", price: "20–40 €" },
              { name: "Geruchsentfernung", price: "30 €" },
              { name: "Ozonbehandlung", price: "50 €" },
            ],
          },
        ],
      },
    },
    gallery: {
      overline: "Galerie",
      title: "Unsere Arbeiten",
      subtitle: "Ergebnisse, die für sich sprechen. Klicken Sie auf ein Foto für die Detailansicht.",
      tabs: { all: "Alle", auto: "Auto", furniture: "Möbel" },
    },
    why: {
      overline: "Warum Hetlav Detailing",
      title: "Qualität, der man vertrauen kann",
      items: [
        {
          title: "Mobiler Service",
          desc: "Wir kommen zu Ihnen in Wien und Umgebung. Kein Transport, keine Umwege.",
        },
        {
          title: "Sicher für Familie",
          desc: "Alle Reinigungsmittel sind zertifiziert und sicher für Kinder und Tiere.",
        },
        {
          title: "Tiefenreinigung",
          desc: "Nicht nur oberflächlich — wir entfernen Schmutz aus der Tiefe der Fasern.",
        },
        {
          title: "Transparente Preise",
          desc: "Ehrliche Preise ohne versteckte Aufschläge. Finaler Preis vor Arbeitsbeginn.",
        },
        {
          title: "1–3 Stunden",
          desc: "Effiziente Arbeit mit professionellem Equipment. Schnell trocken, sofort nutzbar.",
        },
        {
          title: "Garantie",
          desc: "Wir stehen hinter unserer Arbeit. Sichtbares Resultat oder wir machen es richtig.",
        },
      ],
    },
    reviews: {
      overline: "Bewertungen",
      title: "Was unsere Kunden sagen",
      subtitle: "Echte Erfahrungen von Kunden aus Wien",
      addBtn: "Bewertung hinterlassen",
      empty: "Noch keine Bewertungen. Seien Sie der Erste!",
      form: {
        title: "Ihre Bewertung",
        name: "Ihr Name",
        rating: "Bewertung",
        text: "Ihre Erfahrung",
        submit: "Absenden",
        cancel: "Abbrechen",
        thanks: "Vielen Dank! Ihre Bewertung wird nach Prüfung veröffentlicht.",
      },
    },
    booking: {
      overline: "Anfrage senden",
      title: "Buchen Sie Ihren Termin",
      subtitle:
        "Wir rufen Sie zurück und vereinbaren einen Termin, der zu Ihnen passt.",
      fields: {
        name: "Ihr Name",
        phone: "Telefon",
        email: "E-Mail (optional)",
        service: "Gewünschte Leistung",
        message: "Nachricht (optional)",
      },
      services: [
        "Auto Basic — 100 €",
        "Auto Standard — 160 €",
        "Auto Premium — 190 €",
        "Sofa Reinigung",
        "Matratzen Reinigung",
        "Stuhl / Sessel",
        "Sonstiges",
      ],
      submit: "Anfrage absenden",
      sending: "Wird gesendet...",
      success: "Vielen Dank! Wir melden uns in Kürze.",
      error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    },
    footer: {
      tagline: "Premium Detailing in Wien.",
      rights: "Alle Rechte vorbehalten.",
      contact: "Kontakt",
      follow: "Folgen Sie uns",
    },
  },
  ua: {
    nav: {
      home: "Головна",
      services: "Послуги",
      gallery: "Галерея",
      whyUs: "Чому ми",
      reviews: "Відгуки",
      contact: "Контакти",
      cta: "Заявка",
    },
    hero: {
      tagline: "Преміум мобільний сервіс • Відень",
      title1: "Професійна",
      title2: "глибока чистка",
      title3: "з результатом.",
      subtitle:
        "Мобільна хімчистка меблів та автосалонів у Відні. Виїжджаємо до вас — швидко, безпечно, з видимим результатом.",
      ctaPrimary: "Залишити заявку",
      ctaSecondary: "Наші послуги",
      stats: [
        { value: "30+", label: "Виконаних робіт" },
        { value: "4.9", label: "Рейтинг клієнтів" },
        { value: "100%", label: "Безпечно для дітей і тварин" },
      ],
    },
    mobile: {
      badge: "Мобільний сервіс",
      title: "Виїжджаємо до вас додому або в офіс",
      desc: "Hetlav Detailing — повноцінний мобільний сервіс у Відні та околицях. Не потрібно нікуди везти — ми привозимо обладнання до вас.",
    },
    services: {
      overline: "Послуги та ціни",
      title: "Що ми чистимо для вас",
      subtitle:
        "Прозорі ціни без прихованих доплат. Фінальну вартість погоджуємо перед початком роботи.",
      auto: {
        title: "Хімчистка салону авто",
        subtitle: "Глибока чистка інтер'єру автомобіля",
        suv: "SUV / VAN +20 €",
        packages: [
          {
            name: "Basic",
            price: "100",
            features: [
              "Пилосос всього салону",
              "Панель, консоль, двері",
              "Чистка порогів",
              "Скло",
              "Килимки",
              "Легкий аромат",
            ],
          },
          {
            name: "Standard",
            price: "160",
            badge: "Популярний",
            features: [
              "Повний пилосос + багажник",
              "Екстракція сидінь",
              "Екстракція килима",
              "Килимки та пороги",
              "Чистка дверей",
              "Догляд за пластиком + захист",
              "Скло",
              "Фінальний аромат",
            ],
            excludes: ["Стеля не включена", "Глибоке видалення плям не включено"],
          },
          {
            name: "Premium",
            price: "190",
            features: [
              "Повна глибока чистка",
              "Екстракція: сидіння, килим, багажник",
              "Чистка стелі",
              "Видалення складних плям",
              "Пластик + захист",
              "Догляд за шкірою",
              "Скло",
              "Пороги",
              "Фінальний аромат",
            ],
          },
        ],
      },
      addons: {
        title: "Додаткові послуги",
        items: [
          { name: "Екстракція сидінь (5 місць)", price: "80 €" },
          { name: "Багажник", price: "20 €" },
          { name: "Стеля", price: "30 €" },
          { name: "Видалення шерсті тварин", price: "30–50 €" },
          { name: "Сильне забруднення", price: "30 €" },
          { name: "Озонування", price: "50 €" },
          { name: "Вантажівка", price: "від 180 €" },
        ],
      },
      furniture: {
        title: "Хімчистка меблів",
        subtitle: "Дивани, матраци, стільці — чистота до глибини волокон",
        groups: [
          {
            label: "Стільці",
            note: "Ціна залежить від розміру та забруднення",
            items: [
              { name: "Тканинний стілець", price: "25–35 €" },
              { name: "Велике крісло", price: "50–60 €" },
            ],
          },
          {
            label: "Матраци (за сторону)",
            items: [
              { name: "Односпальне ліжко", price: "70 €" },
              { name: "Двоспальне ліжко", price: "100 €" },
              { name: "Друга сторона", price: "+70 € / +100 €" },
              { name: "Сильні плями", price: "+30 €" },
            ],
          },
          {
            label: "Дивани",
            items: [
              { name: "2-місний", price: "120 €" },
              { name: "3-місний", price: "150 €" },
              { name: "Кутовий (L)", price: "180 €" },
              { name: "Великий кутовий (U)", price: "220 €" },
            ],
          },
          {
            label: "Додатково",
            items: [
              { name: "Декоративні подушки", price: "5–10 €" },
              { name: "Сильні плями", price: "20–40 €" },
              { name: "Видалення запаху", price: "30 €" },
              { name: "Озонування", price: "50 €" },
            ],
          },
        ],
      },
    },
    gallery: {
      overline: "Галерея",
      title: "Наші роботи",
      subtitle: "Результати, які говорять самі за себе. Клікніть на фото для детального перегляду.",
      tabs: { all: "Усі", auto: "Авто", furniture: "Меблі" },
    },
    why: {
      overline: "Чому Hetlav Detailing",
      title: "Якість, якій можна довіряти",
      items: [
        {
          title: "Мобільний сервіс",
          desc: "Виїжджаємо до вас у Відень та околиці. Без транспортування та затримок.",
        },
        {
          title: "Безпека для родини",
          desc: "Усі засоби сертифіковані та безпечні для дітей і тварин.",
        },
        {
          title: "Глибоке очищення",
          desc: "Не лише поверхня — видаляємо бруд із самої глибини волокон.",
        },
        {
          title: "Прозорі ціни",
          desc: "Чесні ціни без прихованих доплат. Фінальна вартість узгоджена заздалегідь.",
        },
        {
          title: "1–3 години",
          desc: "Ефективна робота з професійним обладнанням. Швидко висихає, одразу готово.",
        },
        {
          title: "Гарантія",
          desc: "Ми відповідаємо за свою роботу. Видимий результат або переробляємо.",
        },
      ],
    },
    reviews: {
      overline: "Відгуки",
      title: "Що кажуть наші клієнти",
      subtitle: "Справжні враження клієнтів із Відня",
      addBtn: "Залишити відгук",
      empty: "Відгуків поки немає. Будьте першим!",
      form: {
        title: "Ваш відгук",
        name: "Ваше ім'я",
        rating: "Оцінка",
        text: "Ваш досвід",
        submit: "Надіслати",
        cancel: "Скасувати",
        thanks: "Дякуємо! Ваш відгук буде опубліковано після модерації.",
      },
    },
    booking: {
      overline: "Залишити заявку",
      title: "Забронюйте свій візит",
      subtitle: "Ми передзвонимо та узгодимо зручний для вас час.",
      fields: {
        name: "Ваше ім'я",
        phone: "Телефон",
        email: "Email (не обов'язково)",
        service: "Бажана послуга",
        message: "Повідомлення (не обов'язково)",
      },
      services: [
        "Авто Basic — 100 €",
        "Авто Standard — 160 €",
        "Авто Premium — 190 €",
        "Хімчистка дивана",
        "Хімчистка матраца",
        "Стілець / крісло",
        "Інше",
      ],
      submit: "Надіслати заявку",
      sending: "Надсилаю...",
      success: "Дякуємо! Ми зв'яжемось найближчим часом.",
      error: "Щось пішло не так. Спробуйте ще раз.",
    },
    footer: {
      tagline: "Преміум хімчистка у Відні.",
      rights: "Усі права захищені.",
      contact: "Контакти",
      follow: "Ми у соцмережах",
    },
  },
};

export const BRAND = {
  name: "HETLAV DETAILING",
  logoUrl:
    "/images/logo.jpg",
  phone: "+43 688 64767026",
  whatsapp: "+436886476702",
  whatsappUrl: "https://wa.me/436886476702",
  instagram:
    "https://www.instagram.com/hetlav.deteiling?igsh=bjZ3M3UzOTA4OHBp&utm_source=qr",
  facebook: "https://www.facebook.com/share/17KHm9eXMN/?mibextid=wwXIfr",
  tiktok: "https://vm.tiktok.com/ZNRg4hKxF",
  telegramLink: "https://t.me/+436886476702",
  location: "Wien, Österreich",
};
